export const rolesSample = [
  {
    key: 1,
    tableData: [
      {
        serial: "1",
        role: "Super Admin",
        description: "Managing all aspects of an account",
      },
    ],
  },
  {
    key: 2,
    tableData: [
      {
        serial: "2",
        role: "Sub - Admin",
        description: "Help with management tasks on an account",
      },
    ],
  },
  {
    key: 3,
    tableData: [
      {
        serial: "3",
        role: "Sub - Admin",
        description: "Managing all aspects of an account",
      },
    ],
  },
  {
    key: 4,
    tableData: [
      {
        serial: "4",
        role: "Employee",
        description: "We are looking for a capable Program Coordinator",
      },
    ],
  },
  {
    key: 5,
    tableData: [
      {
        serial: "5",
        role: "Super Admin",
        description: "Help with management tasks on an account",
      },
    ],
  },
  {
    key: 6,
    tableData: [
      {
        serial: "6",
        role: "Sub Admin",
        description: "Managing all aspects of an account",
      },
    ],
  },
  {
    key: 7,
    tableData: [
      {
        serial: "7",
        role: "Employee",
        description: "We are looking for a capable Program Coordinator",
      },
    ],
  },
  {
    key: 8,
    tableData: [
      {
        serial: "8",
        role: "Super Admin",
        description: "Managing all aspects of an account",
      },
    ],
  },
  {
    key: 9,
    tableData: [
      {
        serial: "9",
        role: "Employee",
        description: "We are looking for a capable Program Coordinator",
      },
    ],
  },
  {
    key: 10,
    tableData: [
      {
        serial: "10",
        role: "Sub Admin",
        description: "Managing all aspects of an account",
      },
    ],
  },
];
